import React from 'react';
import Carousel from 'better-react-carousel';
import './style.scss';

const Features = () => {
    const autoplay = 2000;
    const responsiveFeature = [
        {
            breakpoint: 1250,
            cols: 1,
            rows: 1,
            gap: 5,
            loop: true,
            autoplay: 2000
        }
    ];
    return (
        <div>
            <Carousel
                cols={1}
                rows={3}
                gap={1}
                showDots={true}
                responsiveLayout={responsiveFeature}
                autoplay={autoplay}
                hideArrow={true}
                mobileBreakpoint={550}
                loop>
                <Carousel.Item>
                    <div className='single-service-container'>
                        <img src={require('../../assets/images/Icons/Task.png')} alt='' style={{ height: '50px' }} />
                        <div className='service-details'>
                            <h3>Billing and Invoicing</h3>
                            <p>Automatically generate and send invoices based on subscription plans and billing cycles.</p>
                        </div>
                    </div>
                </Carousel.Item>
                <Carousel.Item>
                    <div className='single-service-container'>
                        <img src={require('../../assets/images/Icons/invoice.png')} alt='' style={{ height: '50px' }} />
                        <div className='service-details'>
                            <h3>Payment and Revenue Management</h3>
                            <p>Keep track of payments, including successful transactions, failed payments, and upcoming charges.y</p>
                        </div>
                    </div>
                </Carousel.Item>
                <Carousel.Item>
                    <div className='single-service-container'>
                        <img src={require('../../assets/images/Icons/CustomerManagement.png')} alt='' style={{ height: '50px' }} />
                        <div className='service-details'>
                            <h3>Customer Management</h3>
                            <p>Maintain detailed customer profiles with subscription history, preferences, and contact information.</p>
                        </div>
                    </div>
                </Carousel.Item>
                <Carousel.Item>
                    <div className='single-service-container'>
                        <img src={require('../../assets/images/Icons/management.png')} alt='' style={{ height: '50px' }} />
                        <div className='service-details'>
                            <h3>User Roles</h3>
                            <p>Control the resources your team members can access</p>
                        </div>
                    </div>
                </Carousel.Item>
                <Carousel.Item>
                    <div className='single-service-container'>
                        <img src={require('../../assets/images/Icons/support.png')} alt='' style={{ height: '50px' }} />
                        <div className='service-details'>
                            <h3>Customer Support</h3>
                            <p>Provide a system for managing customer support tickets related to subscription issues.</p>
                        </div>
                    </div>
                </Carousel.Item>
                <Carousel.Item>
                    <div className='single-service-container'>
                        <img src={require('../../assets/images/Icons/Compliance.png')} alt='' style={{ height: '50px' }} />
                        <div className='service-details'>
                            <h3>Compliance and Security</h3>
                            <p>We Ensure compliance with Payment Card Industry Data Security Standard.</p>
                        </div>
                    </div>
                </Carousel.Item>
                <Carousel.Item>
                    <div className='single-service-container'>
                        <img src={require('../../assets/images/Icons/communications.png')} alt='' style={{ height: '50px' }} />
                        <div className='service-details'>
                            <h3>Automated Communications</h3>
                            <p>Send automated notifications for billing, subscription changes, and other relevant events</p>
                        </div>
                    </div>
                </Carousel.Item>
                <Carousel.Item>
                    <div className='single-service-container'>
                        <img src={require('../../assets/images/Icons/SubscriptionAnalytics.png')} alt='' style={{ height: '50px' }} />
                        <div className='service-details'>
                            <h3>Subscription Analytics</h3>
                            <p>Generate reports on subscription metrics, customer behavior, and revenue trends.</p>
                        </div>
                    </div>
                </Carousel.Item>
                <Carousel.Item>
                    <div className='single-service-container'>
                        <img src={require('../../assets/images/Icons/SubscriptionManagment.png')} alt='' style={{ height: '50px' }} />
                        <div className='service-details'>
                            <h3>Subscription Managment</h3>
                            <p>Support a variety of subscription models, such as monthly, yearly, tiered plans, and customizable options.</p>
                        </div>
                    </div>
                </Carousel.Item>
            </Carousel>
        </div>
    )
}

export default Features